
import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import { httpclient } from "../../../utils/httpClient";
import moment from "moment/moment";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Tooltip from '@mui/material/Tooltip';

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#3f51b5',
          fontSize: 12,
          fontFamily: "sans-serif !important",
          fontWeight: "bold",

        },
        arrow: {
          color: '#3f51b5',
        },

      },
    },
  },
});


// const title = [
//   { id: "stockLastSyncedDate", name: "Stock Last Synced Date" },
//   { id: "SOHLastSyncedDate", name: "SOH Last Synced Date" },
//   { id: "orderLastSyncedDate", name: "Order Last Synced Date" },
// ];

const title = [
  { id: "stockLastUpdatedDate", name: "Stock Last Updated Date" },
  { id: "SOHLastUpdatedDate", name: "SOH Last Updated Date" },
  { id: "orderLastUpdatedDate", name: "Order Last Updated Date" },
  { id: "supplierLastUpdatedDate", name: "Supplier Last Updated Date" },


];

const DashboardGrid4 = () => {
  const [loading, setLoading] = useState(false);
  const [productStatus, setProductStatus] = useState({});

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 60 * 1000); // Fetch data every 60 seconds
    return () => clearInterval(intervalId); // Cleanup the interval on component unmount
  }, []);

  const fetchData = () => {
    setLoading(true);
    httpclient
      .get(`realtime-status/last-synced-current`)
      .then(({ data }) => {
        if (data.success) {
          setProductStatus(data.data);
          setLoading(false);
        } else {
          console.log("Error!");
        }
      });
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="grid-block-content">
          {title.map((item) => (
            <>
              <div className="grid-item title">{item.name}</div>
              <div className="grid-item content">
                <Skeleton variant="text" />
              </div>
            </>
          ))}
        </div>
      );
    }
    return (


      <div className="grid-block-content">
        {title.map((item) => (
          <>

            <div className="grid-item title">{item.name}</div>
            <div className="grid-item content">{moment(productStatus[item.id]).format("ddd, MMM Do YYYY, h:mm:ss a")}</div>
          </>
        ))}
      </div>
    );
  };
  return (
    <div className="grid-block">
      <div className="grid-block-header">Last data retrieval to SyncCare</div>
      {renderContent()}
    </div>
  );
};

export default DashboardGrid4;
